<template>
  <svg fill="currentColor" id="Bold" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>social-video-youtube-clip</title>
    <path
      d="M20.06,3.5H3.94A3.94,3.94,0,0,0,0,7.44v9.12A3.94,3.94,0,0,0,3.94,20.5H20.06A3.94,3.94,0,0,0,24,16.56V7.44A3.94,3.94,0,0,0,20.06,3.5ZM16.54,12,9.77,16.36A.5.5,0,0,1,9,15.94V7.28a.5.5,0,0,1,.77-.42l6.77,4.33a.5.5,0,0,1,0,.84Z"
    />
  </svg>
</template>
